import React from 'react'
import { Container, QueryStatusAlert } from 'components'
import { MutationStatus } from 'react-query'
import { CustomAxiosError } from 'utils/api'

type BannerProps = {
  children: React.ReactNode
  // Response information to give query feedback if needed
  responseInfo?:
    | {
        status: MutationStatus
        error: CustomAxiosError | null
      }
    | {
        status: MutationStatus
        error: CustomAxiosError | null
      }[]
}

const BannerContents = (children: React.ReactNode) => {
  const numberOfChildren: number = React.Children.count(children)

  if (!children || numberOfChildren <= 0) {
    return []
  }
  if (numberOfChildren === 1) {
    return children
  }

  // Return array of children with dividers in-between
  const contents: any = []
  React.Children.forEach(children, (child, index) => {
    if (index === numberOfChildren - 1) {
      // If last (left-most) child component, don't add the divider
      contents.push(child)
    } else {
      contents.push(child)
      contents.push(<div key={'BannerItem' + index} className="border-r border-primary" />)
    }
  })
  return contents
}

export const Banner: React.FC<BannerProps> = ({ children, responseInfo }) => {
  return (
    <>
      <div
        className="py-2 px-10 flex text-lg"
        style={{
          background: '#BEEEC1',
        }}
      >
        <Container>
          <div className="flex-1 flex justify-end">{BannerContents(children)}</div>
        </Container>
      </div>
      {responseInfo &&
        ((!Array.isArray(responseInfo) && (
          <Container>
            <QueryStatusAlert
              queryStatus={responseInfo.status}
              errorTitle="Could not generate CSV file:"
              errorObj={responseInfo.error}
            />
          </Container>
        )) ||
          (Array.isArray(responseInfo) && (
            <Container>
              {responseInfo.map((item, index) => (
                <QueryStatusAlert
                  key={`banner-download-${index}`}
                  queryStatus={item.status}
                  errorTitle="Could not generate CSV file:"
                  errorObj={item.error}
                />
              ))}
            </Container>
          )))}
    </>
  )
}
